<template>
  <div>
    <!-- SAMPLE REQUESTS BELONGING TO THE LAB ADMIN -->
    <user-sample-requests></user-sample-requests>

    <!-- PUBLICATIONS BELONGING TO THE LAB ADMIN-->
    <user-publications></user-publications>

    <!-- COMPLETE SAMPLE REQUEST-->
    <details>
      <summary>My Functions</summary>
      <div class="header pt-3 blue-gradient">
          <mdb-row class="d-flex justify-content-center">
              <h4 class="white-text mb-3 pt-3"><i class="fas fa-search"></i> Search Approved User Samples</h4>
          </mdb-row>
      </div>
      <div>
        <complete-sample-request></complete-sample-request>
      </div>
    </details>
  </div>
</template>

<script>
import {mdbRow} from "mdbvue";
import UserSampleRequests from "@/components/dashboard/UserSampleRequests";
import UserPublications from "@/components/dashboard/UserPublications";
import CompleteSampleRequest from "@/components/dashboard/CompleteSampleRequest";
export default {
  name: "LabAdminDashboard",
  components: {CompleteSampleRequest, UserPublications, UserSampleRequests, mdbRow}
}
</script>